const insertStyle = () => {
  const style = document.createElement('style');
  style.innerHTML = /* css */ `
    .p6-loading-modal{
      padding: 10px;
      color: rgb(255, 255, 255);
      border-radius: 8px;
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 99999;
      background: rgba(0, 0, 0, 0.7);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-size: 16px;
    }
    .p6-loading-cover{
      color: rgb(255, 255, 255);
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 99999;
    }
    .p6-loading-cover-shadow{
      background: rgba(0, 0, 0, 0.3);
    }
    @keyframes cycle-rotate {
      0% {
        transform: rotate(0);
        -webkit-transform: rotate(0);
      }

      100% {
        transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
      }
    }

    @-webkit-keyframes cycle-rotate {
      0% {
        transform: rotate(0);
        -webkit-transform: rotate(0);
      }

      100% {
        transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
      }
    }
    .icon-common-loading {
      width: 42px;
      height: 42px;
      background-image: url('data:image/png;base64,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');
      background-size: contain;
      animation: cycle-rotate 1.5s linear infinite;
      -webkit-animation: cycle-rotate 1.5s linear infinite;
    }
    `;
  document.head.appendChild(style);
};

function createLoading() {
  insertStyle();

  return (options?: {
    /**
     * 如果有就插入到这个元素，没有就插入到 body 上
     */
    el?: string | Element;
    /** 插入的时候是否清空 innerHTML */
    cleanContent?: boolean;
    /** loading 元素容器样式 */
    className?: string;
    /** loading 元素容器样式 */
    style?: Partial<CSSStyleDeclaration>;
    /** 通过定位覆盖在元素上 */
    cover?: boolean;
    /** cover 的时候有一层黑色遮罩 */
    coverMask?: boolean;
  }) => {
    const $iconLoadingContainer = document.createElement('div');
    const $iconLoading = document.createElement('div');
    $iconLoading.classList.add('icon-common-loading');
    if (options?.className) {
      $iconLoadingContainer.classList.add(options.className);
    }
    if (options?.style) {
      Object.assign($iconLoadingContainer.style, options.style);
    }
    if (options?.cover) {
      $iconLoadingContainer.classList.add(
        ...['p6-loading-cover', options.coverMask ? 'p6-loading-cover-shadow' : ''].filter(Boolean),
      );
    }
    $iconLoadingContainer.appendChild($iconLoading);

    if (options?.el) {
      const $container =
        typeof options.el === 'string' ? document.querySelector<Element>(options.el) : options.el;

      if (options.cleanContent) {
        if ($container) {
          $container.innerHTML = '';
        }
      }
      $container?.appendChild?.($iconLoadingContainer);

      return () => {
        $container?.removeChild?.($iconLoadingContainer);
      };
    }

    const m = document.createElement('div');
    m.classList.add('p6-loading-modal');
    m.appendChild($iconLoading);
    document.body.appendChild(m);

    return () => {
      document.body.removeChild(m);
    };
  };
}

export const openLoading = createLoading();

export const loadingWrapper = <T>(callback: (...args: T[]) => Promise<void>) => {
  let loading = false;
  return async (...args: T[]) => {
    if (loading) {
      return;
    }
    const loadingInstance = openLoading();
    loading = true;
    try {
      await callback(...args);
    } catch (e) {
      console.error(e);
    } finally {
      loading = false;
      loadingInstance();
    }
  };
};

/** 连续点击需要间隔 x 秒 */
export const loadingProtect = (callback: () => void, duration = 300) => {
  let currentTime = Date.now();
  return () => {
    const fireTime = Date.now();
    if (fireTime - currentTime > duration) {
      callback();
      currentTime = fireTime;
    }
  };
};
